import { BaseListRequest, SortByDirection } from "../base.request";

export const ELOAEventEnum = {
    PAGE_VIEW: 'PAGE_VIEW',
    TABLE_NUMBER: 'TABLE_NUMBER',
    SEARCH_CASE: 'SEARCH_CASE',
    SORT_CASES: 'SORT_CASES',
    PAGE_EXIT: 'PAGE_EXIT',
    DOWNLOAD_SUMMARY: 'DOWNLOAD_SUMMARY',
    NAVIGATION_BACKWARD: 'NAVIGATION_BACKWARD',
    NAVIGATION_BREADCRUMB: 'NAVIGATION_BREADCRUMB',
    MAKE_ANOTHER_PAYMENT: 'MAKE_ANOTHER_PAYMENT',
    TABLE_NEXT: 'TABLE_NEXT',
    TABLE_PREVIOUS: 'TABLE_PREVIOUS',
    TABLE_NEXT_10: 'TABLE_NEXT_10',
    TABLE_PREVIOUS_10: 'TABLE_PREVIOUS_10',
}

export type ELOAEventEnumValues = (typeof ELOAEventEnum)[keyof typeof ELOAEventEnum];

export interface ELOAListParams extends BaseListRequest {
    sortBy: string;
    sortByDirection: SortByDirection;
    searchBy: {[x: string]: string} | string | null;
    initialLoad?: boolean;
    fetchId?: string;
}

export interface ELOATransactionRequest {
    paymentMethod?: string;
    paymentTransactionIdList: string[];
    errorMessage?: string;
}

export interface ELOAAuditRequest {   
    event?: ELOAEventEnumValues;
    pageIndex: number;
    pageName: string;
    searchTerm?: string;
    direction?: SortByDirection;
    pageNumber?: number;
    selectedPage?: string;
}

